import React from 'react';
import { Box, Typography } from '@mui/material';

const CardTemplate = ({
  title,
  subtitle,
  action,
  children,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        minWidth: 0,
        backgroundColor: "var(--c-surface)",
        border: "1px solid var(--c-border)",
        borderRadius: "16px",
        boxSizing: "border-box",
        overflow: "hidden",
        transition: "box-shadow 150ms ease",
        "&:hover": { boxShadow: "0 4px 16px rgba(15, 23, 42, 0.06)" },
      }}
    >
      {/* Card header */}
      <Box sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1,
        px: 2.5,
        pt: 2,
      }}>
        <Box sx={{ minWidth: 0 }}>
          <Typography sx={{ fontSize: 15, fontWeight: 600, color: "var(--c-text)", lineHeight: 1.3 }}>
            {title}
          </Typography>
          {subtitle && (
            <Typography sx={{ fontSize: 13, color: "var(--c-text-muted)", lineHeight: 1.4 }} noWrap>
              {subtitle}
            </Typography>
          )}
        </Box>
        {action}
      </Box>

      {/* Content */}
      <Box sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
        gap: 2,
        p: 2.5,
        pt: 2,
        boxSizing: "border-box",
      }}>
        {children}
      </Box>
    </Box>
  )
}

export default CardTemplate;
